import(/* webpackMode: "eager" */ "/home/coder/pubky-app-play/src/app/error.tsx");
